<template>
  <div class="s-vr">
    <!-- <div class="close iconfont icon-close" @click="hide"></div> -->
    <sRightmenu curMenu="vr"  @change="menuClick" v-if="config.slideMenu"></sRightmenu>
    <van-loading  ></van-loading>
    
    <iframe id="myframe" :src="frameSrc" frameborder="0" v-if="show && frameSrc" ></iframe>
    <div class="build" v-else-if="develop">
      <div class="text">正在建设中</div>
    </div>
  </div>
</template>

<script>
import config from '@/config'
import { mapGetters, mapMutations, mapState } from 'vuex'
import rightbox from '../s-rightmenu/rightbox.vue'
import sRightmenu from '../s-rightmenu/s-rightmenu.vue'
export default {
  components: { rightbox,sRightmenu },
  name: 'sVr',
  props: { show:Boolean},
  data(){
    return{
      config,
       /* frameSrc:`https://vr.wanjuan.cn/gsyvr/index.html?sid=319&index=0&openId=${window.openid}&_t=${new Date().getTime()}`,
       oldframeSrc:`https://vr.wanjuan.cn/gsyvr/index.html?sid=319&index=0&openId=${window.openid}&_t=${new Date().getTime()}` */
       frameSrc:window.vrLink,
       oldframeSrc:window.vrLink,
       develop:false
    }
  },
  watch:{
    show:{
      handler(newv,oldv){
        if(newv){
          this.frameSrc = this.oldframeSrc
          // this.stopAudio()
        }else{
          this.frameSrc = ''
        }
        this.stopAudio()
      },immediate:true
    }
  },
  mounted() {
    this.stopAudio() 
    this.getDetail()
  },
methods:{
   ...mapMutations(['audio/updatePlayState']),
   getDetail(){
    let curMap =  config.site.find(t=>{return t.spot == parseInt(this.$route.query.spot)})
      this.$api.featureApi.getFeatureList({typeid:4,bigtype:curMap.spot}).then(res=>{
        if(res && res.data){
          this.showpath = res.showpath
          // this.list = res.data
          this.frameSrc = res.data[0].media_path
          this.oldframeSrc = res.data[0].media_path
          if(!this.frameSrc){
            this.develop = true
          }else{
            this.develop = false
          }
        }else{
          this.develop = true
        }
      })
    },

  hide(){
    this.$emit("hide")
    setTimeout(() => {
      this.frameSrc=''
    }, 500);
  },
  stopAudio(){
    this['audio/updatePlayState'](false)
  },

  menuClick(e){
    if(e.event=='home' || e.event =='back'){
      this.hide()
      return
    }
    this.$emit("changeMode",{
      old:"vr",
      new:e.event
    })
  }
},
}
</script>
<style scoped lang="scss">
  .s-vr{
    width: 100vw;
    height: 100vh;
    position: relative;
    overflow: hidden;
    background: #000;
    .van-loading{
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%,-50%);
      z-index: 1;
    }
    .close{
      position: absolute;
      right: 20rem;
      top: 20rem;
      z-index: 5;
      color: #fff;
      font-size: 24rem;
      cursor: pointer; 
      text-shadow: 0 0 2rem rgba(0, 0, 0, 0.4);
    }
  }
  #myframe,.build{
    width: 100vw;
    height: 100vh;
    position: relative;
    z-index: 2;
  }
  .build{
    background: #000;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 16rem;
    .text{
      opacity: 0.7;
    }
  }

</style>